import { useState } from "react";
import { Box, Tooltip } from "@mui/material";
import AppModal from "../../common/AppModal";
import AppSnackbar from "../../common/AppSnackbar";
import EditSupplierModal from "./supplier-edit-model";
import EditIcon from "../../IconComp/editIcon";
import SupplierBatchIcon from "../../IconComp/supplierBatchIcon";
import SupplierDetailMedModal from "./supplier-detail-med-model";

interface IProps {
  getSupplier: any;
  supplier?: any;
  item: any;
}
export const EditSupplierToolbar = ({
  supplier,
  item,
  getSupplier,
}: IProps) => {

  const [openModal, setOpenModal] = useState(false);
  const [openSupplierDetailModal, setOpenSupplierDetailModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [supplierId, setSupplierId] = useState<string | null>(null);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const handleOpenSupplierDetailModal = (id: string) => {
    setSupplierId(id);
    setOpenSupplierDetailModal(true);
  };

  const handleCloseSupplierDetailModal = () => {
    setOpenSupplierDetailModal(false);
  };

  return (
    <>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "flex-end",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Tooltip title="Edit Supplier" arrow>
          <Box
            component="span"
            sx={{ cursor: "pointer", display: "flex" }}
            onClick={handleOpenModal}
          >
            <EditIcon />
          </Box>
        </Tooltip>

        <Tooltip title="View batches linked to this supplier" arrow>
          <Box
            component="span"
            sx={{ cursor: "pointer", display: "flex" }}
            onClick={() => handleOpenSupplierDetailModal(item.id)} 
          >
            <SupplierBatchIcon />
          </Box>
        </Tooltip>
      </Box>

      <AppModal
        title="Edit Supplier"
        open={openModal}
        handleClose={handleCloseModal}
        fullScreen={false}
        maxWidth="md"
      >
        <EditSupplierModal
          getSupplier={getSupplier}
          handleClose={handleCloseModal}
          setOpenSnackbar={() => setOpenSnackbar(true)}
          supplier={supplier}
          item={item}
        />
      </AppModal>
      <AppModal
        title="Supplier Batch History"
        open={openSupplierDetailModal}
        handleClose={handleCloseSupplierDetailModal}
        fullScreen={false}
        maxWidth="md"
      >
        <SupplierDetailMedModal
          supplierId={supplierId}
        />
      </AppModal>
      <AppSnackbar
        message="Successfully Updated!"
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
      />
    </>
  );
};
